import { render, staticRenderFns } from "./QualityPercentage.vue?vue&type=template&id=a9cb522e"
import script from "./QualityPercentage.vue?vue&type=script&lang=js"
export * from "./QualityPercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports